/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Meta_Synced_HintInputs */

const cs_auth_meta_synced_hint = /** @type {(inputs: Auth_Meta_Synced_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro tento e-mail lze použít přihlášení přes Meta.`)
};

const en_auth_meta_synced_hint = /** @type {(inputs: Auth_Meta_Synced_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta sign-in is available for this email.`)
};

/**
* | output |
* | --- |
* | "Meta sign-in is available for this email." |
*
* @param {Auth_Meta_Synced_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_meta_synced_hint = /** @type {((inputs?: Auth_Meta_Synced_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Meta_Synced_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_meta_synced_hint(inputs)
	return cs_auth_meta_synced_hint(inputs)
});